import {
  CONTACT_EMAIL,
  CONTACT_PHONE,
  COPYRIGHT_INFO,
  TWITTER_X_URL,
  LINKEDIN_URL,
  GITHUB_URL,
} from "../config.js";

function Footer() {
  return (
    <footer className="relative z-20 w-full py-6 bg-white/75 text-gray-600 backdrop-blur-md dark:bg-brand-dark/75 dark:text-gray-400">
      <div className="container mx-auto flex flex-col sm:flex-row justify-around space-y-6 sm:space-y-0">
        <div className="text-center">
          <p className="font-semibold">{"{ David Seibold }"}</p>
        </div>
        <div className="text-center">
          <h3 className="font-bold">Information</h3>
          <p>Phone: {CONTACT_PHONE}</p>
          <p>
            Email:{" "}
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="text-brand-gold hover:text-brand-gold/80 transition-colors"
            >
              {CONTACT_EMAIL}
            </a>
          </p>
          <p>San Diego, CA</p>
        </div>
        <div className="text-center">
          <h3 className="font-bold">Social Media</h3>
          <a
            href={LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block"
          >
            LinkedIn
          </a>
          <a
            href={GITHUB_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block"
          >
            GitHub
          </a>
          <a
            href={TWITTER_X_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block"
          >
            X
          </a>
        </div>
      </div>
      <div className="text-gray-500 text-sm py-4 mt-4 bg-transparent">
        <div className="container mx-auto flex justify-center px-6">
          <p className="text-center">{COPYRIGHT_INFO}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
